export default {
  notification: 'notification'
};
